export default {
  notification: 'notification'
};
